import { aC as a, aO as o } from "./StickyHeaderSkeleton-4367f5a1.mjs";
import { w as n, A as e } from "./Header-417300ac.mjs";
function y(r) {
  const {
    lang: s
  } = a();
  return n({
    url: o(e.CLIENT_V1_MY_CATEGORY),
    queryKey: [e.CLIENT_V1_MY_CATEGORY, {
      lang: s
    }],
    options: {
      suspense: !1,
      useErrorBoundary: !1,
      ...r
    }
  });
}
export {
  y as u
};
